import { Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/** Collapsible section header — title + item count, toggles its content on click. */
export function CollapsibleSectionHeader({
  title,
  count,
  expanded,
  onToggle,
}: {
  title: string;
  count: number;
  expanded: boolean;
  onToggle: () => void;
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      onClick={onToggle}
      sx={{ cursor: 'pointer', userSelect: 'none' }}
    >
      <Typography variant="overline" color="text.secondary">
        {title} ({count})
      </Typography>
      <ExpandMoreIcon
        sx={{
          fontSize: 18,
          color: 'text.secondary',
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.15s',
        }}
      />
    </Stack>
  );
}
